<template>
    <div>
        <div class="video">
            <video width="100%" height="360" controls>
<!--            <source src="/static/mp4/learn_apply.mp4" type="video/mp4" playsinline webkit-playsinline>-->
            <source src="http://new.ynyzxjy.cn/newBaoPublic/static/mp4/learn_apply.mp4" type="video/mp4" playsinline webkit-playsinline>
            </video>
            <div>
                <van-button type="info" size="large" @click="orderQuery" >返回</van-button>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import Vue from 'vue';
import {DropdownMenu, DropdownItem ,Search ,Button } from 'vant';
import OrderQuery from './orderQuery.vue';
Vue.use(Button);
export default {
    name: "learn",
    data() {
        return {
            video: {

            }
        }
    },
    methods:{
        orderQuery(){
            window.history.back();
        }

    }
}

</script>
<style>
.video{
    width: 100%;
    height: 100%;
    margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// learn.vue?89e8e344